<template>
  <div class="start">
    <div class="Slide">
      <header>
        <h1><img src="../assets/images/common/logo.svg" alt="おやこハグネット"></h1>
        <div class="NewsWrapper">
          <div class="News">
            <p>更新情報</p>
            <ul class="NewsSlider">
              <news-list v-for="post of posts" :post="post"></news-list>
            </ul>
          </div>
          <p class="ToBlog"><a v-bind:href="home_url + 'blog/'">≫ ブログ一覧を見る</a></p>
        </div>
      </header>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import $ from 'jquery';
import 'slick-carousel';
import WPURL from '../wp_url';
import NewsList from './NewsList';

const rootURL = WPURL;
const postsURL = `${WPURL}wp-json/wp/v2/posts?_embed&per_page=5`;

Vue.use(VueAxios, axios);

export default {
  name: 'HeaderSlide',
  components: {
    NewsList,
  },

  created() {
    this.getPosts();
  },

  data() {
    return {
      posts: [],
      home_url: rootURL,
    };
  },

  methods: {
    getPosts() {
      Vue.axios.get(postsURL).then((response) => {
        this.posts = response.data;
        const self = this;
        self.initSlick();
      });
    },
    initSlick() {
      // eslint-disable-next-line
      $(function PostSlider() {
        $('.NewsSlider').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          vertical: true,
          autoplay: true,
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../assets/stylesheets/_mixin.scss';
  .Start {
    opacity: 0;
  }
  .Slide {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100vw;
      height: 100vh;
      background-color: #fff;
  }
  h1 {
      margin-top: -2em;
      text-align: center;
  }
  .NewsWrapper {
    width: 100%;
    @include media( sm ) {
      font-size: 1.2rem;
      padding: 0 .5em;
    }
  }
  .News {
      display: flex;
      align-items: center;
      border: 1px solid #ccc;
      border-radius: 1.4rem;
      min-width: calc( 300px - 20px - 2em);
      margin: 0 10px;
      padding: .5em 1em;
      ul, p {
        min-width: 4em;
        margin: 0;
        padding: 0;
        line-height: 1;
      }
      p {
        margin-right: 1em;
      }
      @include media( sm ) {
        width: 500px;
      }
  }
  .ToBlog {
    margin-top: .5em;
    text-align: center;
    @include media( sm ) {
      text-align: right;
    }
  }
</style>



// WEBPACK FOOTER //
// HeaderSlide.vue?7c64a92e